import { collection } from "firebase/firestore";
import { db } from "./firebaseinit";

export const bidsCollectionRef = collection(db, "BidRequest");
export const RankListRequestRef = collection(db, "RankListRequest");
export const bookingTablesRequest = collection(db, "BookingTablesRequest");
export const serviceRequest = collection(db, "ServiceRequest");
export const ScoringRequest = collection(db, "ScoringRequest");
